import {Component, Input, OnInit} from "@angular/core";

import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {IconDefinition} from "@fortawesome/free-solid-svg-icons";
import {DotSpinnerComponent} from "../loaders/dot-spinner.component";

@Component({
    selector: 'clear-button',
  imports: [FontAwesomeModule, FormsModule, DotSpinnerComponent],
    templateUrl: './clear-button.component.html',
    styleUrls: ['./clear-button.component.css']
})
export class ClearButtonComponent implements OnInit {
  @Input('text') text: string = ''
  @Input('marginRight') marginRight: boolean = false
  @Input('customClass') class: string = `border-radius: 8px; padding: 8px 16px; color: ${localStorage.getItem('primaryColor')};`
  @Input('disabledClass') disabledClass: string = 'border border-gray-400 rounded-lg mr-3 text-gray-400 py-2 px-3'
  @Input('faIcon') faIcon:  IconDefinition | null = null
  @Input('disabled') disabled: boolean = false
  @Input('addToClass') addToClass: string = ''
  @Input('isLoading') isLoading: boolean = false

  ngOnInit() {
    if(this.marginRight)
      this.class += ` margin-right: 0.50rem;`
    if(this.addToClass !== '')
      this.class += ' ' + this.addToClass
  }
}
